import { graphql } from "../gql";

export const getClaimAuditGroupsQueryDoc = graphql(`
  query getClaimAuditGroups(
    $first: Int
    $offset: Int
    $orderBy: [ClaimAuditGroupsOrderBy!]
    $filter: ClaimAuditGroupFilter
  ) {
    claimAuditGroups(
      first: $first
      offset: $offset
      orderBy: $orderBy
      filter: $filter
    ) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      nodes {
        appealDueDate
        auditDueDate
        auditStartDate
        auditType
        auditorUserByCreatedBy {
          firstName
          lastName
        }
        clientReportSentDate
        createdAt
        disputeDueDate
        disputeReceivedDate
        docReqDueDate
        dueDate
        finalProviderReportSentDate
        id
        initialProviderReportSentDate
        name
        qaDueDate
        tatStartDate
        totalClaimsCount
      }
    }
  }
`);
